export default function ServicesHero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/a670a1857233b9306d61574a4b8d5a2a.jpg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-stone-900/90 via-stone-900/70 to-emerald-900/50" />
      <div className="relative z-10 w-full px-6 md:px-16 pt-40 pb-24 max-w-7xl mx-auto">
        <span className="text-emerald-400 text-xs font-bold uppercase tracking-widest block mb-4">
          What We Do
        </span>
        <h1
          className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-5 max-w-3xl"
          style={{ fontFamily: "'DM Serif Display', serif" }}
        >
          Comprehensive Global Sourcing &amp; Regulatory Services
        </h1>
        <p className="text-white/70 text-base md:text-lg max-w-2xl leading-relaxed mb-10">
          Full-spectrum sourcing solutions for pharmaceutical and fine chemical industries — from supplier intelligence to end-to-end logistics.
        </p>
        <div className="flex flex-wrap gap-3">
          {['Strategic Sourcing', 'Regulatory Compliance', 'Executive Liaison', 'Logistics & Contracts'].map((tag) => (
            <span
              key={tag}
              className="text-xs font-semibold bg-white/10 border border-white/20 text-white/80 px-4 py-1.5 rounded-full"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
